export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  countriesDetails: {
    countries: "/countries",
    VisaTypeDetails: "/countries/:id/VisaTypeDetails",
    VisaTypeDetailsNationality: "/countries/:id/VisaTypeDetails/nationality",
    countriesGallery: "/countries/:id/gallery",
    countriesFAQ: "/countries/:id/faq/:group_id",
    countriesWorkingProcess: "/countries/:id/working_process/:group_id",
    countriesPrices: "/countries/:visa_type_id/prices/:id",
    groups: "/groups",
    groupsFAQ: "/countries/:id/faq/:group_id",
    groupsWorkingProcess: "/countries/:id/working_process/:group_id",
    groupsPrices: "/groups/:visa_type_id/prices/:id",
    questionnaires: "/questionnaires",
    QuestionsCategory: "/questions_category",
    questionnairesByCategory: "/questions_category/:id/questionnaires",
    documents: "/documents",
    nationality: "/nationality",
    visaType: "/visa-type",
  },
  admins: {
    admins: "/admins",
    privileges: "/privileges",
  },
  admins_logs: {
    admins_logs: "/admins-logs",
  },
  ListDocuments: "/ListDocuments/:from/:id", // from = group / country
  ListQuestions: "/ListQuestions/:from/:id",
  ListQuestionsDocuments: "/ListQuestionsDocuments",
  trustedBy: "/trusted-by",
  testimonials: "/testimonials",
  clients: "/clients",
  working_process: "/working-process",
  stats: "/stats",
  services: "/services",
  contact: "/contact",
  faq: "/faq",
  settings: {
    settings: "/settings",
    legal_information: "/legal_information",
  },
  request_reviews: "/request-reviews/:country_id",
  requests: "/requests",
  request: "/request/:id",
  support: "/support",
  dashboard: "/dashboard",
  home: "/dashboards/ecommerce",
  awards: "/countries/:id/awards",
  userSessions: "/user-ai-chat-sessions/:userId",
};

// export const RouterName = {
//   auth: {
//     login: "/auth/login",
//     signup: "",
//     forgotPassword: "/auth/forgot-password",
//     resetPassword: "/auth/reset-password/:token",
//     maintenance: "/auth/maintenance",
//   },
//   home: {
//     home: "/dashboards",
//   },
//   admins: {
//     admins: "/admins",
//     privileges: "/privileges",
//   },
//   landing_page: {
//     GeneralHomePage: "/general-home-page",
//     ourStory: "/our-story",
//     slidershow: "/slide-show",
//     languages: "/languages",
//     our_client: "/our_client",
//     our_team: "/our_team",
//     testimonials: "/testimonials",
//     app_benefits: "/app_benefits",
//     impacts: "/impacts",
//     stats: "/stats",
//     press_blog_news: "/press_blog_news",
//     maps: "/maps",
//   },
//   settings: {
//     settings: "/settings",
//     legal_information: "/legal_information",
//   },
//   how_it_work: {
//     how_it_work: "/how_it_work",
//     how_it_work_details: "/how_it_work/details/:id",
//   },
//   activities: {
//     category: "/activities/category",
//     activities: "/activities",
//     activities_media: "/activities/media/:id",
//     activities_flashcard: "/activities/flashcard/:id",
//   },
//   topics: {
//     topics: "/topics",
//     SubTopics: "/sub_topics/:id",
//   },
//   flashcard: {
//     flashcard: "/flash_cards",
//     flashcardDetails: "/flash_card/details/:id",
//     flashcardcategory: "/flash_card/categories",
//     level_of_difficulty: "/anything_else",
//     age_range: "/age_range",
//   },
//   ContactAs: {
//     ContactAs: "/contact_us",
//   },
//   faqs: {
//     faqs: "/FAQs",
//   },
//   tips: {
//     tips: "/tips",
//   },
//   users: {
//     users: "/users",
//   },
//   admins_logs: {
//     admins_logs: "/admin_logs",
//   },
//   notification: {
//     notification: "/notification",
//   },
// };
